import { InitEnviromentMethod, QueryEnviromentListModel } from './interface';

export async function initEnviromentAsync(
  envs: Record<string, unknown>,
  method: InitEnviromentMethod,
  params: Pick<QueryEnviromentListModel, 'ProjectName' | 'NamespaceName'>,
) {
  const searchForm: QueryEnviromentListModel = {
    PageIndex: 1,
    PageSize: 1,
    ...params,
  };

  let res = await method(searchForm);
  if (res.PageModel.DataCount > 1) {
    searchForm.PageSize = res.PageModel.DataCount;
    res = await method(searchForm);
  }

  if (res.Data) {
    for (const item of res.Data) {
      if (item.Key in envs) {
        envs[item.Key] = item.Value;
      }
    }
  }

  return res;
}
